// Conditional Plyr loader - only loads when video elements are present
class PlyrLoader {
    constructor() {
        this.loaded = false;
        this.loadingPromise = null;
    }

    async loadPlyr() {
        if (this.loadingPromise) {
            return this.loadingPromise;
        }

        if (this.loaded) {
            return Promise.resolve();
        }

        this.loadingPromise = new Promise(async (resolve, reject) => {
            try {
                // Dynamic import for Plyr - load CSS and JS separately for better chunking
                const [{ default: Plyr }] = await Promise.all([
                    import('plyr'),
                    import('plyr/dist/plyr.css')
                ]);

                this.loaded = true;
                console.log('Plyr loaded successfully');
                resolve(Plyr);
            } catch (error) {
                console.error('Failed to load Plyr:', error);
                reject(error);
            }
        });

        return this.loadingPromise;
    }

    hasVideoElements() {
        return document.querySelectorAll('.plyr-player').length > 0;
    }

    async initializePlayers() {
        const videoElements = document.querySelectorAll('.plyr-player');
        
        if (videoElements.length === 0) {
            // No video players found, don't load Plyr
            console.log('No video elements found, Plyr will not be loaded (saving ~114KB)');
            return [];
        }

        try {
            console.log(`Found ${videoElements.length} video elements, loading Plyr...`);
            const Plyr = await this.loadPlyr();
            
            // Initialize all players
            const players = Array.from(videoElements).map((element) => {
                return new Plyr(element, {
                    controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'],
                    settings: ['captions', 'quality', 'speed'],
                    fullscreen: {
                        enabled: true,
                    },
                });
            });

            console.log(`Initialized ${players.length} Plyr players`);
            return players;
        } catch (error) {
            console.error('Failed to initialize Plyr players:', error);
            return [];
        }
    }
}

// Auto-initialize when DOM is ready
function initConditionalPlyr() {
    const loader = new PlyrLoader();
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            loader.initializePlayers();
        });
    } else {
        loader.initializePlayers();
    }
}

// Initialize
initConditionalPlyr();

// Export for manual initialization if needed
window.PlyrLoader = PlyrLoader;
